import axios from 'axios';
import UserRewardClaimTable, {
  tableColumns
} from 'components/tables/UserRewardClaimTable';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const UserRewardClaim = () => {
  const { id } = useParams();
  const token = localStorage.getItem('token');
  const [transaction, setTransaction] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    fetchUserRewardClaims();
  }, [id, pagination]);

  const fetchUserRewardClaims = async () => {
    const url = `/transaction/reward-claim`;

    let params: Record<string, any> = {
      page: pagination.pageIndex + 1,
      pageSize: pagination.pageSize
    };

    if (id) {
      params = { ...params, userId: id };
    }

    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}${url}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: params
      }
    );
    errorHandler(response);
    if (response.data['status'] == 'error') {
      toast.error(response.data['message']);
      return false;
    }
    setTransaction(response.data['data']['rewardClaims']);
    setTotalRecords(response.data['data']['totalRecords']);
  };
  const handlePaginationChange = (updater: any) => {
    const newState =
      typeof updater === 'function' ? updater(pagination) : updater;
    setPagination(newState);
  };
  const table = useAdvanceTable({
    data: transaction,
    columns: tableColumns,
    pageSize: pagination.pageSize,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {}
    },
    meta: {
      manualPagination: true,
      totalRecords: totalRecords,
      onPaginationChange: handlePaginationChange,
      pagination: pagination,
      fetchUserRewardClaims: fetchUserRewardClaims
    }
  });
  return (
    <div>
      <h3 className="mb-4">
        Claim Records{' '}
        <span className="text-body-tertiary fw-normal">({totalRecords})</span>
      </h3>
      <AdvanceTableProvider {...table}>
        <UserRewardClaimTable />
      </AdvanceTableProvider>
    </div>
  );
};

export default UserRewardClaim;
